<template>
  <div>
    <nav :class="color">
      <div class="navContainer container">
        <div class="itemContainer">
          <ul v-if="items.length > 0">
            <li v-for="item in items" :key="item.label" class="navItems">
              <template v-if="item.path">
                <a :href="item.path" target="_blank">{{ item.label }}</a>
              </template>
              <template v-else>
                <router-link :to="item">{{ item.label }}</router-link>
              </template>
              
            </li>
            <li class="toggle">
              <a @click="triggerNav()" v-if="!active">
                <BaseIcon
                  icon="hamburger"
                  variant="light"
                  color="#ffffff"
                  width="30"
                  height="30"
                />
              </a>
              <a @click="triggerNav()" v-if="active">
                <BaseIcon
                  icon="close"
                  variant="light"
                  color="#ffffff"
                  width="30"
                  height="30"
                />
              </a>
            </li>
          </ul>
        </div>
        <div class="logoContainer">
              <a
                class="icon-link"
                href="https://www.instagram.com/kickandquatsch"
                target="_blank"
                rel="noopener"
              >
                <Icon
                  icon="mdi:instagram"
                  color="#000000"
                  width="20"
                  height="20"
                />
              </a>
              <a
                class="icon-link"
                href="https://www.facebook.com/kickandquatsch"
                target="_blank"
                rel="noopener"
              >
                <Icon
                  icon="mdi:facebook"
                  color="#000000"
                  width="20"
                  height="20"
                />
              </a>
              <a
                class="icon-link"
                href="https://open.spotify.com/show/7yG8udb8cMI5qg3ZIkG4B6"
                target="_blank"
                rel="noopener"
              >
                <Icon
                  icon="mdi:spotify"
                  color="#000000"
                  width="20"
                  height="20"
                />
              </a>
              <a
                class="icon-link"
                href="https://podcasts.apple.com/de/podcast/kick-and-quatsch/id1546702903"
                target="_blank"
                rel="noopener"
              >
                <Icon
                  icon="hugeicons:apple-music"
                  color="#000000"
                  width="20"
                  height="20"
                />
              </a>
        </div>
      </div>
    </nav>
    <div
      v-if="type === 'foldout' && active == true"
      class="foldout"
      :class="color"
    >
      <div class="navContainer container">
        <ul>
          <li v-for="item in items" :key="item.label" @click="triggerNav()">
            <router-link :to="item">{{ item.label }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="type === 'cover' && active == true" class="cover" :class="color">
      <div class="navContainer container">
        <ul>
          <li v-for="item in items" :key="item.label" @click="triggerNav()">
            <router-link :to="item">{{ item.label }}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon.vue";
import { Icon } from "@iconify/vue2";

export default {
  components: {
    BaseIcon,
    Icon
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: "cover",
    },
    color: {
      type: String,
      default: "light",
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    triggerNav() {
      if (this.active == true) {
        this.active = false;
      } else {
        this.active = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.icon-link {
  background-color: #fff;
  padding: 8px;
  margin: 0px 4px;
  border-radius: 100%;
}
</style>
